export const removeDuplicatesFromArray = (array, keyToBeUnique) =>
  keyToBeUnique
    ? array.filter(
        (x, xi) => !array.slice(xi + 1).some((y) => y[keyToBeUnique] === x[keyToBeUnique])
      )
    : array.filter((v, i, self) => i === self.indexOf(v));
